<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Production Report</h4>
      </el-col>
      <el-col :sm="12">
        <div class="text-right">
          <el-button type="primary" size="small" @click="dialogView = true">
            Filter <span class="el-icon-search"></span>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-dialog ref="dialog" :visible.sync="dialogView" title="Report Filter">
      <el-form label-position="left" label-width="120px">
        <el-form-item label="Report Type">
          <el-select
            v-model="report"
            @change="setReportFilter"
            placeholder="Select Report Type"
            clearable
            filterable
          >
            <el-option
                  v-for="w in report_list"
                  :value="w.value"
                  :key="w.value"
                  :label="w.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Month">
            <el-date-picker
            v-model="value1"
            :type="dType"
            :placeholder="dPlaceholder">
            </el-date-picker>
        </el-form-item>
        <el-form-item v-if="!isDaily" label="Customers">
          <el-select
            multiple 
            v-model="customer"
            placeholder="Select Customer here"
            clearable
            filterable
          >
            <el-option
                  v-for="d in customer_list"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :disabled="btnDisable" @click="generate">Generate Report</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import ULD from "@/models/ULD";
import moment from "moment";
// import Part from "@/models/Part";
export default {
  name: "ProductionReport",
  computed: {
    suppliers() {
      return this.$store.getters["supplier/glossary"];
    },
    report_url() {
      let url = `/api/v1/inventory/download_inventory/?`;
      if (this.pager.supplier_id) {
        url += `&supplier_id=${this.pager.supplier_id}`;
      }
      if (this.pager.item_type) {
        url += `&item_type=${this.pager.item_type}`;
      }

      return url;
    }
  },
  data() {
    return {
      list: { data: [], paging: {} },
      parts: [],
      is_cost_summary: 0,
      isDaily: false,
      pager: {
        page: 1,
        limit: 25,
        search: "",
        supplier_id: "",
        item_type: "",
      },
      dialogView: false,
      dType: "month",
      dPlaceholder: "Pick a month",
      value1: "",
      customer: "",
      report: "",
      customer_list: [],
      btnDisable: false,
      isLoading: true,
      report_list: [
            {
                value: "Daily Production Report",
                label: 0
            },
            {
                value: "Monthly Production Report",
                label: 1
            },
            {
                value: "Monthly Repair Cost Summary",
                label: 2
            },
            {
                value: "Yearly Production Report",
                label: 3
            }
      ],
    };
  },
  methods: {
    customers_data() {
        ULD.customers_data().then(list => {
            this.customer_list = list;
        });
    },
    generate() {        
        let fullyr = moment(this.value1).format("YYYY-MM");
        let fulldate = moment(this.value1).format("YYYY-MM-DD");
        let fname = moment(this.value1).format("YYYY-MMMM ")
        let qyear = moment(this.value1).year();
        let month = moment(this.value1).format("MM");
        let customer_id = this.customer.join();
        var reportInfo = {
            name: this.report + '-' + fname,
            ext: ".xlsx"
        };
        this.isLoading = true;
        this.btnDisable = true;
        if(this.is_cost_summary === 0) {
            api.download(`api/v1/repair/monthly_prod_report/?customer_id=${customer_id}&year=${qyear}&month=${month}`, reportInfo).then(() => {
              this.isLoading = false;
              this.btnDisable = false;
            });
        } else if(this.is_cost_summary === 1) {
            api.download(`api/v1/repair/uld/?monthly_cost_report=1&date=${fullyr}&year=${qyear}&month=${month}&per_customer_id=${customer_id}`, reportInfo).then(() => {
              this.isLoading = false;
              this.btnDisable = false;
            });
        } else if(this.is_cost_summary === 2) {
            api.download(`api/v1/repair/yearly_prod_report/?customer_id=${customer_id}&year=${qyear}`, reportInfo).then(() => {
              this.isLoading = false;
              this.btnDisable = false;
            });
        } else if(this.is_cost_summary === 3) {
            api.download(`api/v1/repair/daily_prod_report/?date=${fulldate}`, reportInfo).then(() => {
              this.isLoading = false;
              this.btnDisable = false;
            });
        }
      
    },
    setReportFilter() {
        if(this.report === 'Daily Production Report') {
            this.is_cost_summary = 3;
            this.isDaily = true;
            this.dType = 'date';
            this.dPlaceholder = "Pick a day";
            return false;
        } 
        if(this.report === 'Monthly Repair Cost Summary') {
            this.is_cost_summary = 1;
            return false;
        } 
        if(this.report === 'Yearly Production Report') {
            this.is_cost_summary = 2;
            return false;
        }
        this.dType = 'month';
        this.dPlaceholder = "Pick a month";
        this.is_cost_summary = 0;
        this.isDaily = false;
        this.value1 = null;
    }

  },
  mounted() {
    this.dialogView = false;
    this.isLoading = false;
    this.customers_data();
    // Part.getGlossary().then(list => {
    //   this.parts = list;
    // });
  }
};
</script>

<style lang="css" scoped></style>
